// extracted by mini-css-extract-plugin
export var productImage = "_zm-0";